import { Box, Flex, Image, Spinner, Text, useToast } from '@chakra-ui/react'
import React from 'react'
import { Input } from './Input'
import { MdOutlineMail, MdLockOutline } from 'react-icons/md'
import { FaUser } from 'react-icons/fa'
import { RadioInput } from './RadioInput'
import { useForm } from 'react-hook-form'
import { Button } from './Button'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { acessarSistema, ListaTelasCRM } from '../../services/api'
import { useMutation } from 'react-query'
import { RandomImageBox } from './RandomImageBox'

const schema = z.object({
  email: z.string().nonempty('E-mail é obrigatório'),
  password: z.string().min(2, 'Senha muito curta'),
})

export const NewLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm({
    resolver: zodResolver(schema),
  })
  const [manterConectado, setManterConectado] = React.useState(false)

  const toast = useToast({
    position: 'top',
    duration: 5000,
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation(
    async (data) => {
      const response = await acessarSistema.post('', data)
      return response.data
    },
    {
      onSuccess: async (data) => {
        console.log('data', data)
        localStorage.setItem('authentication', JSON.stringify(data))

        try {
          const responseTelas = await ListaTelasCRM.get()
          const dadostela = responseTelas.data

          localStorage.setItem('telascarregadas', JSON.stringify(dadostela))

          if (JSON.parse(localStorage.getItem('authentication'))) {
            const permissoes = JSON.parse(localStorage.getItem('authentication')).permissoes_usuario
            const telas = JSON.parse(localStorage.getItem('telascarregadas'))

            for (const perm in permissoes) {
              if (permissoes[perm].telainicial === 'S') {
                window.location.href = telas[perm].link_menu
              }
            }
          }
        } catch (error) {
          toast({
            title: 'Erro ao acessar sistema!',
            description: 'Erro ao acessar sistema!',
            status: 'error',
          })
        }
      },
      onError: (error) => {
        toast({
          title: 'Erro ao acessar sistema!',
          description: 'Erro ao acessar sistema!',
          status: 'error',
        })
      },
    }
  )

  async function onSubmit(data) {
    console.log(data)

    const params = {
      email: data.email,
      senha: data.password,
    }

    await mutateAsync(params)
  }

  return (
    <Box bgColor="#FBFBFB" minH="100vh" w="100%" display="flex" justifyContent="center" py={{ base: '15px', md: '50px' }} alignItems="center">
      <Flex
        flexDirection={{ base: 'column', lg: 'row' }}
        gap={{ base: '20px', md: '11px' }}
        flex={1}
        justifyContent="center"
        alignItems="start"
        maxW={{ base: '100%', xl: '1300px' }}
        px={{ base: '15px', md: '0' }}
      >
        <Box display={{ base: 'none', md: 'block' }} flex={{ base: '1', lg: '2' }} maxW={{ base: '100%', lg: '100%' }} w="100%">
          <RandomImageBox />
        </Box>
        <Box
          w="100%"
          maxW={{ base: '100%', sm: '374px' }}
          as="fieldset"
          disabled={isSubmitting}
          _disabled={{
            opacity: 0.5,
            pointerEvents: 'none',
            cursor: 'not-allowed',
          }}
        >
          <Flex
            px={{ base: '15px', sm: '25px' }}
            py="30px"
            flexDir="column"
            gap="31px"
            maxW={{ base: '100%', sm: '374px' }}
            minH="456px"
            flex={1}
            w="100%"
            boxShadow="0px 3px 6px rgba(43, 43, 43, 0.14)"
            bg="white"
            as="form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Flex flexDir="column" gap="10px" alignItems="center" justifyContent="center">
              <Box w="40px" h="40px" bgColor="#3C3C3C" borderRadius="full" display="flex" justifyContent="center" alignItems="center">
                <FaUser fontSize="20px" color="white" />
              </Box>
              <Text fontSize="18px" color="#3F484F">
                Bem Vindo (a)
              </Text>
            </Flex>

            <Flex flexDir="column" gap="22px">
              <Input id="email" Icon={MdOutlineMail} placeholder="E-mail" {...register('email')} />
              {errors.email && <Text color="red.500">{errors.email.message}</Text>}
              <Input type="password" id="password" Icon={MdLockOutline} placeholder="Senha" {...register('password')} />
              {errors.password && <Text color="red.500">{errors.password.message}</Text>}
            </Flex>

            <Flex gap={3} alignItems="center">
              <RadioInput
                name="manterConectado"
                value="manterConectado"
                checked={manterConectado}
                onClick={() => setManterConectado(!manterConectado)}
              />
              <Text fontSize="14px" color="#3F484F">
                Manter conectado?
              </Text>
            </Flex>
            <Button>
              {isSubmitting ? (
                <Flex gap={2} alignItems="center" justifyContent="center">
                  <Spinner size="sm" color="black" />
                  <Text ml="10px">Entrando...</Text>
                </Flex>
              ) : (
                'Entrar'
              )}
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}
